import script from "./BottomMenuBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomMenuBar.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/btm_menu_bar.css?vue&type=style&index=0&id=126bbf21&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126bbf21"]])

export default __exports__